import React from "react";
import { FiDownload } from "react-icons/fi";

const PeseeToolbar = ({
  total,
  isDemo,
  onExportCsv,
  exportDisabled = false,
  children,
}) => {
  return (
    <div className="w-full rounded-2xl border border-slate-200 bg-white/80 p-3 shadow-sm backdrop-blur dark:border-white/10 dark:bg-slate-900/80">
      <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
        <div className="min-w-0">
          <p className="text-sm text-slate-600 dark:text-slate-300">
            Total affiché :{" "}
            <span className="font-bold text-slate-950 dark:text-white">
              {total}
            </span>{" "}
            compétiteur{total > 1 ? "s" : ""}
          </p>

          {isDemo && (
            <p className="mt-1 text-xs font-semibold text-yellow-700 dark:text-yellow-300">
              Démo : utilisez l’import dédié “judokas fictifs”.
            </p>
          )}
        </div>

        <div className="flex flex-wrap gap-2">
          {children}

          {typeof onExportCsv === "function" && (
            <button
              type="button"
              onClick={onExportCsv}
              disabled={exportDisabled}
              className={`inline-flex min-h-10 items-center gap-2 rounded-xl px-3 py-2 text-sm font-bold transition ${
                exportDisabled
                  ? "cursor-not-allowed bg-slate-200 text-slate-500 dark:bg-slate-800 dark:text-slate-400"
                  : "bg-emerald-600 text-white shadow-sm hover:bg-emerald-700"
              }`}
              title="Exporter les compétiteurs filtrés"
            >
              <FiDownload className="h-4 w-4" />
              Export CSV
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PeseeToolbar;